import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { OnboardingTourStepDataObject } from '../../../models/service/login';

type CalendarOnboardingStepRequest = {
  meta: {
    selected_calendar_options: string[];
  };
  status: 'completed';
};

type DefaultOnboardingStepRequest = {
  status: 'completed';
};

type OnboardingStepRequest = CalendarOnboardingStepRequest | DefaultOnboardingStepRequest;

export const updateOnboardingStep = async (id: string, data: OnboardingStepRequest) =>
  apiClient.patch<OnboardingTourStepDataObject, ApiClientResponse<OnboardingTourStepDataObject>>(
    routes.onboardingSteps.update(id),
    data,
  );
